// src/pages/KeywordSearch.js
import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5001';

export default function KeywordSearch() {
  const [locationCode, setLocationCode] = useState('IN');
  const [languageCode, setLanguageCode] = useState('hi');
  const [keywords, setKeywords] = useState('');
  const [isUserRegistered, setIsUserRegistered] = useState('True');
  const [authToken, setAuthToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResponseData(null);

    if (!keywords.trim()) {
      setError('Please enter keywords.');
      return;
    }

    const payload = [
      {
        location_code: locationCode,
        language_code: languageCode,
        keywords: keywords.trim(),
        is_user_registered: isUserRegistered
      }
    ];

    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE}/keyword-search`,
        { payload, authorization: authToken },
        { headers: { 'Content-Type': 'application/json' } }
      );

      setResponseData(res.data);
    } catch (err) {
      console.error('Keyword search error', err);
      if (err.response && err.response.data) {
        setError(JSON.stringify(err.response.data));
      } else {
        setError(String(err.message || err));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">🔎 Keyword Search (YouTube relevancy)</h2>

      <form onSubmit={handleSubmit} className="space-y-3 mb-6">
        <div>
          <label className="block text-sm font-medium">Location code</label>
          <input value={locationCode} onChange={(e) => setLocationCode(e.target.value)} className="w-full p-2 border rounded" />
        </div>

        <div>
          <label className="block text-sm font-medium">Language code</label>
          <input value={languageCode} onChange={(e) => setLanguageCode(e.target.value)} className="w-full p-2 border rounded" />
        </div>

        <div>
          <label className="block text-sm font-medium">Keywords</label>
          <input value={keywords} onChange={(e) => setKeywords(e.target.value)} className="w-full p-2 border rounded" placeholder="e.g. HDFC BANK" />
        </div>

        <div>
          <label className="block text-sm font-medium">Is user registered</label>
          <select value={isUserRegistered} onChange={(e) => setIsUserRegistered(e.target.value)} className="w-full p-2 border rounded">
            <option value="True">True</option>
            <option value="False">False</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium">Authorization token (optional)</label>
          <input value={authToken} onChange={(e) => setAuthToken(e.target.value)} className="w-full p-2 border rounded" placeholder="token if required" />
        </div>

        <div>
          <button type="submit" disabled={loading} className="px-4 py-2 bg-blue-600 text-white rounded">
            {loading ? 'Processing...' : 'Submit'}
          </button>
        </div>
      </form>

      {error && <div className="text-red-600 mb-4">Error: {error}</div>}

      {responseData && (
        <div className="bg-gray-50 border p-4 rounded">
          <h3 className="text-lg font-semibold">Response</h3>
          <pre className="overflow-auto text-sm mt-2">{JSON.stringify(responseData, null, 2)}</pre>
          <div className="mt-2 text-sm text-gray-600">
            CSV saved to S3: <code>digiadglobal-anylatics/keyword_search_responses.csv</code> (if backend returned 200).
          </div>
        </div>
      )}
    </div>
  );
}
